<template>
  <div class="place-order-wrap" v-loading="tableData.length === 0">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/framework/home' }">报价首页</el-breadcrumb-item>
      <el-breadcrumb-item>下单</el-breadcrumb-item>
    </el-breadcrumb>
    <header-title title="商品信息" />
    <content-table v-if="tableData.length !== 0" :tableData="tableData" labelWidth="110" />
    <div class="form-wrap">
      <el-form label-width="120px">
        <el-form-item label="业务办理">
          <el-radio-group v-model="operateIndex">
            <div class="radio-wrapper">
              <p v-for="(item, index) in detailData.situationList" :key="index" class="radio-box">
                <el-radio :label="index">
                  <span class="radio-val">{{ item.situationName }}</span>
                  <span class="radio-label">购销计划：</span>
                  <span class="radio-val">{{ item.contractList[0] }}</span>
                  <span class="radio-label">升贴水单价：</span>
                  <span class="radio-val"><span class="fb f20 c-orange m-r-5">{{ item.liftingWaterTotal }}</span>元/吨</span>
                </el-radio>
              </p>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="购买数量" required>
          <!--下面的onkeypress函数是为了屏蔽用户输入除数字外的其它字符，包括科学计数法的e和负号-等-->
          <el-input v-model="orderQuantity"
                    class="num"
                    @input="countDeposit"
                    maxlength="10"
                    onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" />
          <span>吨</span>
          <template v-if="orderQuantity">
            <span class="tip" v-if="detailData.saleableQuantity < orderQuantity"><i class="el-icon-warning"></i>下单数量不能大于剩余数量</span>
            <span class="tip" v-if="detailData.minQuantity > orderQuantity"><i class="el-icon-warning"></i>下单数量不能小于最少摘牌量</span>
          </template>
        </el-form-item>
        <el-form-item label="下单备注">
          <el-input type="textarea" v-model="remark" maxlength="50" placeholder="请输入下单备注"></el-input>
        </el-form-item>
        <div class="warning-tip" v-if="freezingQuantity && orderQuantity && Number(orderQuantity) > 0">
          下单将冻结挂牌商品履约金{{ freezingQuantity }}元，当前账户可用挂牌商品履约金{{ thawedQuantity }}元
        </div>
      </el-form>
    </div>
    <div class="bottom-border"></div>
    <div class="button_wrap over">
      <el-button type="primary"
                 @click="submit"
                 :loading="loading"
                 :disabled="!(isLogin && (qualificationType === 'ALL' || qualificationType === 'B'))">
        下单
      </el-button>
      <el-button type="left-button plain" @click="operteShoppingCart" v-if="isLogin">
        {{ isCollect === '20' ? '加入购物车' : '移出购物车' }}
      </el-button>
      <el-button type="left-button plain" @click="back">
        返回
      </el-button>
    </div>
    <div class="warning-tip" v-if="!isLogin">提示：登录后才可下单</div>
    <div class="warning-tip" v-if="isLogin && (qualificationType === 'S' || qualificationType === '')">
      提示：您尚未开通下单权限，请联系客服4006230066
    </div>
    <div class="empty-box"></div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import contract from './components/contract'
const { mapState } = createNamespacedHelpers('framework')
export default {
  name: 'PlaceTheOrder',
  components: {
    contract
  },
  data () {
    return {
      orderQuantity: '',
      remark: '', // 备注
      detailData: { // 详情数据
        saleableQuantity: 0, // 剩余数量
      },
      tableData: [], // 详情表格数据
      buyerDepositObj: {}, // 挂牌商品履约金对象
      freezingQuantity: '', // 冻结货款
      thawedQuantity: '', // 未冻结货款
      contract: '', // 最后定价合约
      firstContract: '', // 首个合约
      sellerContract: '', // 卖方定价合约
      spanMonthOrder: '', // 是否跨月
      isCollect: false, // 当前报价是否被收藏
      showContract: false, // 显示购销计划的选择框
      buyerDepositRate: 1, // 履约金比例
      operateIndex: 0,
      loading: false
    }
  },
  watch: {
    isLogin (val) {
      if (val) { // 登录信息改变了，从未登录变成登录，请求挂牌商品履约金数据
        this.getBuyerDeposit()
      }
    },
    operateIndex (val) {
      this.contract = this.detailData.situationList[val].contractList[0]
      this.countDeposit()
    }
  },
  computed: {
    ...mapState({
      qualificationType: 'qualificationType',
      isLogin: 'isLogin',
    }),
  },
  mounted () {
    this.getDetails()
    if (this.isLogin) {
      this.getBuyerDeposit()
    }
  },
  methods: {
    // 获取详情
    getDetails () {
      const url = this.$API.MyQuotation.detailContango
      const param = {
        id: this.$route.params.id
      }
      this.$http.post(url, param).then(res => {
        this.detailData = res.data
        this.isCollect = this.detailData.isCollect // 是否被收藏
        this.sellerContract = this.detailData.contract
        this.tableData = [ // 详情表格数据
          { key: '品种', value: this.detailData.varietyName },
          { key: '品类', value: this.detailData.category },
          { key: '品牌', value: this.detailData.brandName },
          { key: '等级', value: this.detailData.grade },
          { key: '产地', value: this.detailData.origin },
          { key: '榨季', value: this.detailData.season },
          { key: '可交货时间', value: this.detailData.deliveryDate.substr(0, 10) },
          { key: '剩余数量', value: this.detailData.saleableQuantity },
          { key: '最少摘牌量', value: this.detailData.minQuantity },
          { key: '交货地', value: this.detailData.addressStr },
          { key: '交货方式', value: this.getDeliveryType(this.detailData.deliveryType) },
          { key: '仓租费起始日', value: this.detailData.warehouseRentStartDate.substr(0, 10) },
          { key: '货款要求', value: this.detailData.loanRequire + '前支付' },
          { key: '仓库名', value: this.detailData.wareHouseAddress || '无' },
          { key: '报价备注', value: this.detailData.remark },
        ]
        this.contract = this.detailData.situationList[this.operateIndex].contractList[0]
        // 神策数据收集
        this.$sensors.track('ContangoOperation', { operation: '浏览商品详情页面', BrowseGoodsDetails: this.tableData })
        this.showContract = true
      })
    },
    // 获取未冻结余额
    getFreezingQuantity () {
      const url = this.$API.releaseQuotation.queryUserErpAccount
      this.$http.post(url, {}).then(res => {
        this.thawedQuantity = res.data.amount
        this.buyerDepositRate = res.data.buyerDepositRate
        this.countDeposit()
      })
    },
    // 获取挂牌商品履约金对象
    getBuyerDeposit () {
      const url = this.$API.releaseQuotation.basedatadictsub
      const param = {
        currentNo: 1,
        dictCode: 'ContangoBuyerDeposit',
        dictStatus: '1',
        pageSize: 50
      }
      // 根据查询的挂牌商品履约金列表，得到对应的挂牌商品履约金对象
      this.$http.post(url, param).then((res) => {
        res.data.rows.forEach((item) => {
          this.buyerDepositObj[item.dictSubCode] = item.dictSubValue
        })
        this.getFreezingQuantity()
      })
    },
    // 获取首个合约
    getFirstContract (contract) {
      this.firstContract = contract
    },
    // 计算冻结货款
    countDeposit () {
      const needNotGradeCategory = ['ContangoCategoryCST', 'ContangoCategoryHT', 'ContangoCategoryBPT', 'ContangoCategoryPT'] // 不需要等级的品种
      if (this.orderQuantity && this.contract) {
        // 选择的合约的是否与第一个合约相同，是的话是当月，否的话跨月（DY代表当月，KY代表跨月）
        const spacing = 'DY'
        this.spanMonthOrder = 'N' // 后台需要(暂时写死)
        /**
         * code用来查询挂牌商品履约金，由品类，月份跨度标识，等级拼接而成，分为两类
         * needNotGradeCategory这个数组中的品种不需要拼接上等级，不在这个数组的需要在后面拼接上等级
         * **/
        let code = needNotGradeCategory.includes(this.detailData.variety) ? `${this.detailData.categoryCode}_${spacing}` : `${this.detailData.categoryCode}_${spacing}_${this.detailData.gradeCode}`
        this.freezingQuantity = Number(this.buyerDepositObj[code]) * Number(this.orderQuantity) * this.buyerDepositRate // 计算冻结货款
      } else {
        this.freezingQuantity = '' // 信息填写不完整就把冻结货款重置为空
      }
    },
    // 校验
    check () {
      if (!this.orderQuantity || parseInt(this.orderQuantity) === 0) {
        this.$message.error('请填写大于0的购买数量')
        return false
      } else if (parseInt(this.detailData.saleableQuantity) < parseInt(this.orderQuantity)) {
        this.$message.error('下单数量不能大于剩余数量')
        return false
      } else if (parseInt(this.detailData.saleableQuantity) < parseInt(this.orderQuantity)) {
        this.$message.error('下单数量不能大于剩余数量')
        return false
      } else if (Number(this.freezingQuantity) > Number(this.thawedQuantity)) {
        this.$message.error('下单将冻结挂牌商品履约金不能多于当前账户未冻结挂牌商品履约金')
        return false
      } else {
        return true
      }
    },
    // 获取交货方式
    getDeliveryType (type) {
      if (type) {
        const statusItem = this.$key.releaseQuotation.deliveryType.filter((item) => { // 找到匹配当前状态的那个项
          return item.id === type
        })
        return statusItem[0].name // 返回想要的状态描述
      } else {
        return ''
      }
    },
    // 购物车相关操作
    operteShoppingCart () {
      // isCollect='10'代表当前报价是被收藏的，‘20’代表还没有收藏
      const url = this.isCollect === '10' ? this.$API.shoppingCart.cancelCollect : this.$API.shoppingCart.collect
      const param = {
        id: this.$route.params.id
      }
      this.$http.post(url, param).then(res => {
        if (res.succeed) {
          this.$message.success('操作成功')
          // 神策数据收集
          this.$sensors.track('OperationGoodsDetailsPage', { operation: '商品详情页面操作', shopping_cart: '加入购物车' })
          this.isCollect = this.isCollect === '10' ? '20' : '10' // 更改当前页面的收藏状态
        }
      })
    },
    // 下单
    submit () {
      if (this.check()) { // 校验通过
        const url = this.$API.releaseQuotation.getPcUserDepositRate
        // 神策数据收集
        this.$sensors.track('OperationGoodsDetailsPage', { operation: '商品详情页面操作', order: '下单' })
        this.loading = true
        this.$http.post(url, {}).then(res => {
          if (res.data.buyerDepositRate === this.buyerDepositRate) { // 履约金没有发生变化，提交数据
            this.submitData()
          } else {
            // 履约金发生变化，提示用户
            this.buyerDepositRate = res.data.buyerDepositRate
            this.countDeposit()
            this.loading = false
            this.$alert('履约金优惠折扣发生变化，请重新确认履约金金额', {
              confirmButtonText: '确定'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }
    },
    // 提交数据
    submitData () {
      const url = this.$API.quotation.addContangoOrder
      const param = {
        contangoCode: this.detailData.contangoCode,
        orderQuantity: parseInt(this.orderQuantity),
        spanMonthOrder: 'N',
        remark: this.remark,
        buyerContract: this.detailData.situationList[this.operateIndex].contractList[0],
        situationCode: this.detailData.situationList[this.operateIndex].situationCode,
        situationName: this.detailData.situationList[this.operateIndex].situationName,
        liftingWater: this.detailData.situationList[this.operateIndex].liftingWaterTotal,
        orderTerminal: 'WEB'
      }
      this.$http.post(url, param).then((res) => {
        this.loading = false
        this.$message.success('下单成功')
        // 将订单信息储存进storage,下个页面展示要用
        sessionStorage.contangoOrderData = JSON.stringify(res.data)
        // 订单成功页
        this.$router.replace({ path: `/framework/home/placeTheOrder/orderSuccess/${res.data.orderCode}/${res.data.cashDeposit}` })
      }).catch(() => {
        this.loading = false
        // 下单失败
        this.$router.replace({ path: `/framework/home/orderFailed` })
      })
    },
    // 返回上一页
    back () {
      // 神策数据收集
      this.$sensors.track('OperationGoodsDetailsPage', { operation: '商品详情页面操作', return: '返回' })
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .place-order-wrap{
    margin-top: 20px !important;
    .form-wrap{
      margin-top: 20px;
      margin-bottom: 35px;
      .price{
        font-size: 30px;
        color: #ff7f00;
        margin-right: 6px;
        vertical-align: bottom;
      }
      .num{
        width: 130px;
        margin-right: 6px;
      }
      .tip{
        font-size: 12px;
        color: #ff1010;
        margin-left: 10px;
      }
      /deep/ .el-textarea{
        width: 350px;
      }
      .radio-wrapper{
        margin-top: 14px;
      }
      .radio-box{
        margin-bottom: 15px;
      }
      .radio-val{
        color: #333333;
      }
      .radio-label{
        color: #333333;
        margin-left: 30px;
      }
    }
    .button_wrap{
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        margin-top: 40px;
        margin-bottom: 20px;
      }
    }
  }
</style>
